module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/elements/buttons-8f207a80b94e1e3acd48d662e5039609.svg";